<style lang="css">
.chainId-dropdown {
  width: 400px;
  height: 300px;
  background-color: #fff;
  border: 1px solid #dcdfe6;
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.16);
  position: relative;
}

.chainId-dropdown .ivu-input-wrapper {
  position: absolute;
  right: 10px;
  top: 8px;
  z-index: 999;
}

.chainId-dropdown .ivu-input {
  border-radius: 0;
}

.pulldown .vxe-pulldown--content {
  display: flex;
  align-items: center;
  justify-content: center;
}

</style>

<template>
  <div>
    <vxe-pulldown ref="sellerDown" transfer class="pulldown">
      <template>
        <a :title="row[field]"
           v-if="isSalesMan"
           style="
            display: inline-block;
            text-algin: center;
            color: #606266;
          "
        >{{ row[field] }}</a
        >
        <a :title="row[field]"
           v-else
           class="link-text"
           @click="focusEvent"
           target="_black"
           :style="isEdit ? 'cursor: pointer;display: inline-block;text-align: center;color:#2d8cf0;' :'cursor: pointer;display: inline-block;text-align: center;color:#606266;'"
        >{{
            row[field] == null || row[field] == "" ? placeholder : row[field]
          }}</a
        >
        <img v-if="!isSalesMan && isEdit && row[field] && clearable"
             style="height: 10px;width: 10px;cursor: pointer;"
             src="~assets/images/common/close.png"
             @click.stop="removeSales"/>
      </template>
      <template v-slot:dropdown>
        <div class="chainId-dropdown">
          <Input
              search
              suffix="ios-search"
              v-model="userName"
              placeholder
              @on-search="search"
              style="width: 200px"
          />
          <vxe-grid
              border="none"
              highlight-hover-row
              auto-resize
              height="auto"
              :loading="loading"
              :pager-config="tablePage"
              :data="tableList"
              :columns="tableColumn"
              @cell-click="cellClickEvent"
              @page-change="pageChange"
          ></vxe-grid>
        </div>
      </template>
    </vxe-pulldown>
  </div>
</template>


<script>
import $api from "@/apiProvider";
import {isEmpty, isNotEmpty} from "@/utils/util";
import getAuthOrization from "@/mixin/getAuthOrization";

export default {
  mixins: [getAuthOrization],
  name: "SalesMan",
  props: {
    row: {
      type: Object,
      default: null,
    },
    field: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "选择业务员",
    },
    rowIndex: {
      default: null,
    },
    isEdit: {
      type: Boolean,
      default: true,
    },
    isFlow: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isSalesMan: false,
      userName: "",
      salesMan: null, // 业务员
      tableColumn: [{field: "name", title: "姓名"}], // 表格数据列
      tableList: [], // 业务员列表
      loading: false,
      tablePage: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
        size: "mini",
      },
    };
  },
  mounted() {
    // console.log(this.userInfoValue);
    if (this.userInfoValue.identityType === 0) {
      this.isSalesMan = true;
      if (!this.isFlow) {
        this.cellClickEvent({
          row: {
            id: this.userInfoValue.id,
            name: this.userInfoValue.name,
          },
        });
      }
    }
  },
  methods: {
    removeSales() {
      this.row[this.field] = null;
    },
    pageChange(e) {
      this.tablePage.currentPage = e.currentPage;
      this.tablePage.pageSize = e.pageSize;
      this.getUserList();
    },
    focusEvent() {
      if (!this.isEdit || this.isSalesMan) {
        return;
      }
      this.tablePage.currentPage = 1;
      this.userName = "";
      this.getUserList();
      this.$refs.sellerDown.showPanel();
    },
    search() {
      this.tablePage.currentPage = 1;
      this.getUserList();
    },
    async cellClickEvent({row}) {
      this.row.isSalesMan = this.isSalesMan;
      this.$set(this.row, this.field, row.name);
      this.$set(this.row, this.field + "Id", row.id);
      this.$set(this.row, this.field + "Kh", null);
      this.$set(this.row, this.field + "KhId", null);
      this.$set(this.row, this.field + "Xs", null);
      this.$set(this.row, this.field + "XsId", null);
      // 查询详情  获取  销售经理 和 客户代表
      let res = await $api.baseUserSales.request("querySalesDetail", {
        id: row.id,
      });
      if (res.status === 1) {
        this.$set(this.row, this.field + "Xs", res.data.salesManager);
        this.$set(this.row, this.field + "XsId", res.data.salesManagerId);
        this.$set(this.row, this.field + "Kh", res.data.clientManager);
        this.$set(this.row, this.field + "KhId", res.data.clientManagerId);
        res.data.rowIndex = this.rowIndex;
        this.$emit("setSaleMan", res.data);
      } else if (res.status === 10003) {
        this.$set(this.row, this.field + "Xs", null);
        this.$set(this.row, this.field + "XsId", null);
        this.$set(this.row, this.field + "Kh", null);
        this.$set(this.row, this.field + "KhId", null);
        var obj = {rowIndex: this.rowIndex};
        this.$emit("setSaleMan", obj);
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
      if (isNotEmpty(this.$refs.sellerDown)) {
        this.$refs.sellerDown.hidePanel();
      }
    },
    async getUserList() {
      let params = {
        orderBy: 2,
        page: this.tablePage.currentPage,
        rows: this.tablePage.pageSize
      };

      if (isNotEmpty(this.userName)) {
        params.userName = this.userName;
      }
      if (isEmpty(this.tableList)) {
        this.loading = true;
      }

      let res = await $api.user.request("querySaleManagerList", params);
      this.loading = false;
      if (res.status === 1) {
        this.tablePage.total = res.data.total;
        this.tableList = res.data.rows;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
  },
};
</script>